import type { Handler } from './handler';
import type { ApiFetchOfficialProfilePort } from './ports/api-fetch-official-profile.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchOfficialProfileHandler: Handler<
  Params,
  Ports,
  Result
> = async (
  params,
  ports = {
    apiFetchOfficialProfile: resolveAdapter('apiFetchOfficialProfile'),
  },
) => {
  const [profile, fetchError] = await tryCatch(
    ports?.apiFetchOfficialProfile.handle(params.slug),
  );

  if (fetchError) {
    console.error(
      '[fetchOfficialProfileHandler] Erro ao buscar perfil oficial:',
      fetchError,
    );

    return { profile: null };
  }

  return { profile };
};

type Params = { slug: string };

type Ports = {
  apiFetchOfficialProfile: ApiFetchOfficialProfilePort;
};

type Result = Promise<{ profile: OfficialProfileDetail | null }>;
